import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { confirmDialog } from '@/ui_v3';

/**
 * InfoInitializeConfirmModal hook
 *
 * 상위 항목 변경 시 하위 정보 초기화 확인 모달을 여는 hook입니다.
 * 번역을 캡슐화하여 React 컴포넌트 내에서만 사용할 수 있습니다.
 */
export const useInfoInitializeConfirmModal = () => {
  const {
    t
  } = useTranslation(['build', 'common']);
  const openInfoInitializeConfirmModal = useCallback(async () => {
    return await confirmDialog.openAsync({
      header: {
        title: t('build.category.parentChangeWarningTitle')
      },
      body: t('build.category.parentChangeWarningMessage'),
      cancelText: t('common:global.cancel.button'),
      cancelIntent: 'neutral',
      confirmText: t('common:global.confirm.button'),
      confirmIntent: 'strong',
      shouldCloseOnDimClick: false
    });
  }, [t]);
  return {
    openInfoInitializeConfirmModal
  };
};